import React, { useContext, useState } from 'react';
import Icon from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import {
  ExpertExpertiseSvg,
  ExpertProfileSvg,
  GerbSvg,
  LeftArrowSvg,
  NmsMeetingSvg,
  NmsMembersSvg,
  RepresentativeAppSvg,
  RepresentativeProfileSvg,
  RightArrowSvg,
} from '../../icons';
import { routerPath } from '../../router/routerPath';
import { authContext } from '../../store/authStore/AuthContext';
import { CollapseItem, LkNavbarContainerUI, NavbarItem, NavbarItems, NavbarLink, ScreenDarker } from './styled';

export const LkSidebarComponent = () => {
  const url = useLocation().pathname;
  const { state } = useContext(authContext);
  const [collapsed, setCollapsed] = useState<boolean>(false);

  return (
    <div style={{ overflow: 'hidden', height: '100%', zIndex: '100' }}>
      <LkNavbarContainerUI collapsed={collapsed}>
        <NavbarItems>
          <NavbarItem logo collapsed={collapsed}>
            <Link to={routerPath.mainpage}>
              <Icon component={() => <img src="/icons/books.svg" alt="books" />} />
            </Link>
            <Link to={routerPath.mainpage}>
              <Link to="/">
                <div className="logo-layout">
                  <h2>Федеральный перечень учебников</h2>
                </div>
              </Link>
            </Link>
          </NavbarItem>
          {(state.isFederal || state.isSuperFederal) && (
            <>
              <NavbarLink to={routerPath.application}>
                <NavbarItem active={url.includes(routerPath.application)}>
                  <Icon component={() => <img src="/icons/application.svg" alt="books" />} />
                  <div className="layout">Заявления</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.expert}>
                <NavbarItem active={url.includes(routerPath.expert) && !url.includes(routerPath.expertise)}>
                  <Icon component={() => <img src="/icons/expert.svg" alt="books" />} />
                  <div className="layout">Эксперты</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.expertise}>
                <NavbarItem active={url.includes(routerPath.expertise)}>
                  <Icon component={() => <img src="/icons/expertise.svg" alt="books" />} />
                  <div className="layout">Экспертиза</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.textbooks}>
                <NavbarItem active={url.includes(routerPath.textbooks)}>
                  <Icon component={() => <img src="/icons/hoveredbooks.svg" alt="books" />} />
                  <div className="layout">Учебники</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.publisher}>
                <NavbarItem active={url.includes(routerPath.publisher)}>
                  <Icon component={() => <img src="/icons/publisher.svg" alt="books" />} />
                  <div className="layout">Издательства</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.representative}>
                <NavbarItem active={url.includes(routerPath.representative)}>
                  <Icon component={() => <img src="/icons/representative.svg" alt="books" />} />
                  <div className="layout">Представители издательств</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.nmsMembers}>
                <NavbarItem active={url.includes(routerPath.nmsMembers)}>
                  <Icon component={() => <NmsMembersSvg />} />
                  <div className="layout">Члены НМС</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.nmsMeeting}>
                <NavbarItem active={url.includes(routerPath.nmsMeeting)}>
                  <Icon component={() => <NmsMeetingSvg />} />
                  <div className="layout">Заседания НМС</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.lkPovs}>
                <NavbarItem active={url.includes('povs')}>
                  <Icon component={() => <GerbSvg />} />
                  <div className="layout">ПОВС</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.document_category}>
                <NavbarItem active={url.includes('document_category')}>
                  <Icon component={() => <img src="/icons/documents.svg" alt="books" />} />
                  <div className="layout">Документы</div>
                </NavbarItem>
              </NavbarLink>
            </>
          )}
          {state.isRepresentative && (
            <>
              <NavbarLink to={routerPath.representativeProfile}>
                <NavbarItem active={url.includes(routerPath.representativeProfile)}>
                  <div className="svg-container">
                    <RepresentativeProfileSvg />
                  </div>
                  <div className="layout">Профиль</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.representativeApplication}>
                <NavbarItem active={url.includes(routerPath.representativeApplication)}>
                  <div className="svg-container">
                    <RepresentativeAppSvg />
                  </div>
                  <div className="layout">Заявления</div>
                </NavbarItem>
              </NavbarLink>
            </>
          )}
          {state.isPovs && (
            <>
              <NavbarLink to={routerPath.povsLk}>
                <NavbarItem active={url.includes(routerPath.povsLk) && url.split('/').length === 3}>
                  <div className="svg-container">
                    <RepresentativeProfileSvg />
                  </div>
                  <div className="layout">Профиль</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.povsLkDocuments}>
                <NavbarItem active={url.includes(routerPath.povsLkDocuments)}>
                  <div className="svg-container">
                    <RepresentativeAppSvg />
                  </div>
                  <div className="layout">Экспертизы</div>
                </NavbarItem>
              </NavbarLink>
            </>
          )}
          {state.isNms && (
            <>
              <NavbarLink to={routerPath.nmsProfile}>
                <NavbarItem active={url.includes(routerPath.nmsProfile) && url.split('/').length === 3}>
                  <div className="svg-container">
                    <RepresentativeProfileSvg />
                  </div>
                  <div className="layout">Профиль</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.nmsProfileMeeting}>
                <NavbarItem active={url.includes(routerPath.nmsProfileMeeting)}>
                  <div className="svg-container">
                    <RepresentativeAppSvg />
                  </div>
                  <div className="layout">Материалы заседаний</div>
                </NavbarItem>
              </NavbarLink>
            </>
          )}
          {state.isExpert && !state.isPovs && (
            <>
              <NavbarLink to={routerPath.expertUserProfile}>
                <NavbarItem active={url.includes(routerPath.expertUserProfile)}>
                  <div className="svg-container">
                    <ExpertProfileSvg />
                  </div>
                  <div className="layout">Профиль</div>
                </NavbarItem>
              </NavbarLink>
              <NavbarLink to={routerPath.expertExpertise}>
                <NavbarItem active={url.includes(routerPath.expertExpertise)}>
                  <div className="svg-container">
                    <ExpertExpertiseSvg />
                  </div>
                  <div className="layout">Экспертизы</div>
                </NavbarItem>
              </NavbarLink>
            </>
          )}
          <CollapseItem
            onClick={() => {
              setCollapsed(!collapsed);
            }}
          >
            {collapsed ? <LeftArrowSvg /> : <RightArrowSvg />}
          </CollapseItem>
        </NavbarItems>
      </LkNavbarContainerUI>
      {collapsed && (
        <CSSTransition timeout={300} classNames={'transition'}>
          <ScreenDarker
            onClick={() => {
              setCollapsed(!collapsed);
            }}
          />
        </CSSTransition>
      )}
    </div>
  );
};
